// extracted by mini-css-extract-plugin
export var container = "_8b-0";
export var error = "_8b-9";
export var label = "_8b-5";
export var light = "_8b-6";
export var md = "_8b-3";
export var sm = "_8b-2";
export var thin = "_8b-8";
export var thinBold = "_8b-7";
export var vertical = "_8b-4";
export var xs = "_8b-1";